<div class="assetCard__detailsValuesContainer">
  @for (detail of detailsList; track detail) {
    <div class="assetCard__detailField">
      <label class="assetCard__detailLabel">{{ detail.key | ppTranslate }}</label>
      <span
        class="assetCard__detailsValue"
        ppTooltip
        [ppTrimTooltip]="true"
        [ppTitle]="detail.value"
        [innerHtml]="detail.value | highlightKeyword: keyword"
      ></span>
    </div>
  }
</div>
